import { InjectionToken } from '@angular/core';
import { PatientFormValue } from './patient-form.service';

// A persisted draft has the same shape as the live form value.
export type PatientDraft = PatientFormValue;

// Context the form provides to the draft store on every call. Practice id is
// part of the key so drafts don't leak across practices; user id is *not*
// part of this contract — implementations resolve it themselves (the
// localStorage impl reads AuthenticationService) so the dumb form has no
// AuthenticationService dependency.
export interface DraftKeyContext {
  practiceId: number | string | null | undefined;
}

// Stateful capability the host environment supplies for storing in-progress
// patient form drafts. Synchronous because the current implementation is
// localStorage-backed; if a portal needs an async/HTTP-backed implementation
// later, change the interface then.
export interface PatientDraftStore {
  save(value: PatientFormValue, ctx: DraftKeyContext): void;
  load(ctx: DraftKeyContext): PatientDraft | null;
  clear(ctx: DraftKeyContext): void;
}

export const XCS_PATIENT_DRAFT_STORE = new InjectionToken<PatientDraftStore>(
  'XCS_PATIENT_DRAFT_STORE',
);
